import {MARKETING_VIEWS} from 'app-constants'

let messages = {}
messages = Object.assign(messages,
  require('./about/en.json'),
  require('./shared/en.json'),
  require('./login-register/en.json'),
  require('./sitebuilder/templates/en.json'),

)

for (let view of MARKETING_VIEWS) {
  messages = Object.assign(messages, require(`./${view}/en.json`))
}

export default messages


// WEBPACK FOOTER //
// ./apps/www.bravenet.com/src/i18n/index.js